import { DATABASE } from './model.js';

export function fromTable(table) {
  return DATABASE[table];
};

/* var addFieldToTable = (field, toTable) => {

}; */

export var addEntry = (newEntry) => {
  DATABASE[newEntry.key] = newEntry.type;
};

export var matchEntriesToModel = (header, entries) => {
  return new Promise((resolve, reject) => {
    let fieldCheck = {};
    Object.keys(MODEL).map(field => fieldCheck[field] = header.includes(field) ? 1 : 0);
    let matchingHeader = !Object.values(fieldCheck).includes(0);
    resolve({
      matchingHeader,
      fieldCheck,
      entries,
      header
    });
  });
};